import ForgetPassword from "../../../../jsx/pages/Connector/ForgotPassword";

const LoginWrapper = function (props) {
  return <ForgetPassword />;
};

export default constore(LoginWrapper);
